import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createTicket,
  fetchTickets,
  updateTickets,
} from "../features/tickets/ticketsThunks";
import { useParams, useNavigate } from "react-router-dom";

export default function AddEditTicket() {
  const isEditMode = window.location.pathname.includes("edit-ticket");
  const { tickets } = useSelector((state) => state.tickets);
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (tickets.length === 0) {
      dispatch(fetchTickets());
    }
  }, [dispatch, tickets.length]);

  const editTicket = tickets.find((ticket) => String(ticket.id) === id);

  useEffect(() => {
    if (isEditMode && editTicket) {
      setFormData({
        title: editTicket.title,
        description: editTicket.description,
        priority: editTicket.priority,
        status: editTicket.status,
        ticketType: editTicket.ticketType,
      });
    }
  }, [isEditMode, editTicket]);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    status: "open",
    priority: "low",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.title || !formData.description) return;

    if (isEditMode) {
      dispatch(
        updateTickets({
          id,
          updatedData: {
            title: formData.title,
            description: formData.description,
            status: formData.status,
            priority: formData.priority,
          },
        })
      );
    } else {
      dispatch(
        createTicket({
          title: formData.title,
          description: formData.description,
          status: formData.status,
          priority: formData.priority,
          createdAt: new Date().toISOString(),
        })
      );
    }

    navigate("/tickets");
  };

  return (
    <div>
      {isEditMode ? (
        <h2 className="mb-4">Edit Ticket</h2>
      ) : (
        <h2 className="mb-4">Add New Ticket</h2>
      )}
      <div className="card p-4">
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="title"
            value={formData.title || ""}
            onChange={handleChange}
            className="form-control mb-3"
            placeholder="Title"
          />
          <textarea
            name="description"
            value={formData.description || ""}
            onChange={handleChange}
            className="form-control mb-3"
            placeholder="Description"
          ></textarea>

          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="form-select mb-3"
          >
            <option value="open">Open</option>
            <option value="in-progress">In Progress</option>
            <option value="closed">Closed</option>
          </select>

          <select
            name="priority"
            value={formData.priority}
            onChange={handleChange}
            className="form-select mb-3"
          >
            <option value="low">Low</option>
            <option value="medium">Medium</option>
            <option value="high">High</option>
          </select>

          {isEditMode ? (
            <button className="btn btn-primary w-100" type="submit">
              Update Ticket
            </button>
          ) : (
            <button className="btn btn-primary w-100" type="submit">
              Add Ticket
            </button>
          )}
        </form>
      </div>
    </div>
  );
}
